import { hotTrends } from "@/mocks/home-data";
import SectionHeading from "./SectionHeading";

const rankColor = ["bg-primary-500", "bg-accent-500", "bg-secondary-500"];

export default function BaoliaoModule() {
  const maxHot = Math.max(...hotTrends.map((t) => t.hot));

  return (
    <section id="baoliao" className="border-t border-background-200 bg-background-100/50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          kicker="爆料汇总 · 热雷指数榜"
          title={<>热雷指数榜，这一分钟谁最烫</>}
          desc="把近一周的爆料汇总成一张热度榜单，指数越高越炸。榜单每小时刷新一次，供吃瓜群众决定下一场去蹲哪里。"
        />

        <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="flex items-center justify-between border-b border-background-200 bg-background-100/70 px-4 py-3 md:px-6">
            <span className="font-label text-xs font-semibold uppercase tracking-[0.18em] text-primary-600">
              Top 6 热雷排行
            </span>
            <span className="flex items-center gap-1.5 font-label text-xs text-foreground-500">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-75" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500" />
              </span>
              实时更新
            </span>
          </div>

          <ul className="flex flex-col">
            {hotTrends.map((t, i) => (
              <li key={t.rank}>
                <a
                  href="#mailuo"
                  className="group flex items-center gap-4 border-b border-background-100 px-4 py-4 transition-colors last:border-b-0 hover:bg-background-100/70 md:gap-6 md:px-6"
                >
                  <span
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-sm font-black text-background-50 ${
                      rankColor[i] ?? "bg-secondary-400"
                    }`}
                  >
                    {String(t.rank).padStart(2, "0")}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <h3 className="font-label text-sm font-semibold text-foreground-950 md:text-base">
                        {t.title}
                      </h3>
                      <span className="rounded-full bg-secondary-100 px-2 py-0.5 font-label text-[11px] font-medium text-secondary-900">
                        {t.tag}
                      </span>
                    </div>
                    <div className="mt-2 h-1.5 w-full max-w-md overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-gradient-to-r from-accent-500 to-primary-500 transition-all duration-700"
                        style={{ width: `${(t.hot / maxHot) * 100}%` }}
                      />
                    </div>
                  </div>
                  <div className="flex shrink-0 items-center gap-1.5 font-label text-sm font-bold text-primary-600">
                    <i className="ri-fire-fill" /> {t.hot}
                  </div>
                  <i className="ri-arrow-right-s-line hidden text-xl text-secondary-400 transition-transform group-hover:translate-x-1 md:inline-flex" />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}